"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var LabelText = function LabelText(_ref) {
  var label = _ref.label,
      description = _ref.description;
  return (0, _preact.h)("div", null, (0, _preact.h)("div", {
    className: "panel-switch-label-text"
  }, label), (0, _preact.h)("div", {
    className: "panel-switch-label-meta"
  }, description));
};

var _default = LabelText;
exports.default = _default;